import { isObject as $isObject, isNil } from 'lodash'

const isObject = (value) => $isObject(value) || isNil(value)

export { isObject }
